function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: props.color || 'currentColor',
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || 'currentColor',
  d: "M2.683 4.371c.929 0 1.682-.755 1.682-1.686C4.365 1.755 3.612 1 2.683 1 1.753 1 1 1.755 1 2.685c0 .931.753 1.686 1.683 1.686Zm3.271 1.277V15h2.898v-4.624c0-1.22.23-2.402 1.74-2.402 1.49 0 1.508 1.395 1.508 2.479V15H15V9.872c0-2.52-.541-4.455-3.48-4.455-1.412 0-2.358.776-2.744 1.51h-.04V5.648H5.954Zm-4.723 0h2.903V15H1.23V5.65Z"
}));
export default SvgLinkedin;